<template>
  <data-table
    :headers="headers"
    :endpoint="endpoint"
    :fields="fields"
    :filters="filters"
    :actions="['pdf-button']"
    :title="$t('invoices-vendor')"
    :file-name="fileName"
    :modal="modal"
    show-search
  >
  </data-table>
</template>

<script>
import dataTable from '@/components/layout/datatable/data-table.vue';
import store from '@/store';
import g4100TypesQuery from '@/utils/g4100TypesQuery';

export default {
  name: 'invoice-providers',
  data: () => ({
    providerId: '',
    fileName: 'factura',
    headers: [
      {
        text: 'Código',
        align: 'start',
        sortable: false,
        value: 'cod',
      },
      { text: 'Serie', value: 'id_serie', sortable: false },
      { text: 'Fecha', value: 'fecha' },
      { text: 'Referencia externa', value: 'referencia_externa' },
      { text: 'Observaciones', value: 'observaciones' },
      { text: 'Importe', value: 'total', align: 'end' },
      { text: 'Situación', value: 'id_situacion_pago', sortable: false },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    endpoint: 'facturasC',
    fields: ['id', 'cod', 'fecha', 'id_tipo', 'id_proveedor', 'referencia_externa', 'observaciones', 'total', 'id_situacion_pago', 'id_serie'],
    filters: {
      offset: 0,
      where: [
        {
          field: 'id_proveedor',
          condition: g4100TypesQuery.TYPE_QUERY_EQUAL,
          value: String(store.getters.user.vendor.id),
        },
      ],
    },
    modal: {
      headers: [
        {
          text: 'Código',
          align: 'start',
          sortable: false,
          value: 'documento.cod',
        },
        { text: 'Documento', value: 'documento.value' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      fields: ['id', 'documento', 'facturasC'],
      endpoint: 'union_documentos_facturasC',
    },
  }),
  components: {
    dataTable,
  },
};
</script>
